import { useSelector } from "react-redux";

import LazyLoad from "../../../../components/LazyLoad/component";
import { TrendingListSidebar } from "../../../../components/TrendingList";
import { DetailMoreStories } from "../../../../components/MoreStories/component";
import Recommendations from "../../../../components/Recommendations/component";
import CommentsAndAd from "../CommentsAndAd/component";
import TrendingVideos from "../VideoTrending/component";
import { SECTIONS } from "../../../../../app/constants/sections";

const TrendingList = () => {
    const { baseSection, section } = useSelector((state) => state.app);

    const isPreviewContent = useSelector(
        (state) => state.detail.content.isPreview
    );

    if (isPreviewContent) return null;

    if (SECTIONS[baseSection]) {
        // Displays localized trending list on regional story pages
        const displaySection = SECTIONS[section]?.displayLocalTrending
            ? section
            : baseSection;

        return (
            <LazyLoad>
                <TrendingListSidebar
                    section={displaySection}
                    trendingHeaderOverride={
                        SECTIONS[displaySection].trendingSidebarLabel || null
                    }
                />
            </LazyLoad>
        );
    }
};

const Discovery = ({ components = [] }) => {
    const discoveryComponents = {
        trending: <TrendingList />,
        trendingVideos: <TrendingVideos />,
        recommendations: <Recommendations />,
        comments: <CommentsAndAd />,
        discoverMore: <DetailMoreStories />,
    };
    if (components.length === 0) {
        return null;
    }

    return components.map((component) => (
        <div className="detailDiscovery" key={component}>
            {discoveryComponents[component]}
        </div>
    ));
};
export default Discovery;
